import { Dimmer as SemanticDimmer } from 'semantic-ui-react';

export { DimmerProps, StrictDimmerProps } from 'semantic-ui-react';

export const Dimmer: typeof SemanticDimmer = SemanticDimmer;

export default Dimmer;
